import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AccessDenied.css";

const AccessDenied = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const rawPath = location.pathname;
    const displayPath = rawPath.length > 48 ? rawPath.slice(0, 45) + "…" : rawPath;

    return (
        <div className="e403-root">
            <div className="e403-panel">
                <div className="e403-content">
                    <span className="e403-eyebrow">Error 403</span>
                    <div className="e403-numeral" aria-hidden="true">403</div>
                    <h1 className="e403-headline">Access Denied</h1>
                    <p className="e403-body">
                        You don't have permission to view this page.
                        Contact your administrator if you believe this is an error.
                    </p>
                    <div className="e403-url-badge" title={rawPath}>
                        <span className="e403-url-label">Requested path</span>
                        <code className="e403-url-path">{displayPath}</code>
                    </div>
                    <div className="e403-actions">
                        <button className="e403-btn-primary" onClick={() => navigate("/Dashboard")}>
                            Go to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessDenied;
